import React from 'react';
interface SplitImageSectionProps {
  imageUrl: string;
  leftLabel: string;
  leftCopy: string;
  rightLabel: string;
  rightCopy: string;
  caption: string;
  reverse?: boolean;
}
export const SplitImageSection = ({
  imageUrl,
  leftLabel,
  leftCopy,
  rightLabel,
  rightCopy,
  caption,
  reverse = false
}: SplitImageSectionProps) => {
  return <section className="relative w-full" data-id="element-211">
      <div className="relative w-full h-[500px] md:h-[700px] lg:h-[800px]" data-id="element-212">
        <img src={imageUrl} alt="" className="w-full h-full object-cover" data-id="element-213" />
        <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-2" data-id="element-214">
          <div className={`flex items-end justify-center p-4 pb-6 md:p-16 md:pb-20 ${reverse ? 'md:order-2' : ''}`} data-id="element-215">
            <div className="glass-card p-6 md:p-12 rounded-2xl md:rounded-3xl max-w-md text-center w-full" data-id="element-216">
              <h3 className="text-2xl md:text-4xl font-light mb-3 md:mb-4" data-id="element-217">
                {leftLabel}
              </h3>
              <p className="text-gray-600 text-xs md:text-base leading-relaxed" data-id="element-218">
                {leftCopy}
              </p>
            </div>
          </div>
          <div className={`hidden md:flex items-end justify-center p-4 pb-6 md:p-16 md:pb-20 ${reverse ? 'md:order-1' : ''}`} data-id="element-219">
            <div className="glass-card p-6 md:p-12 rounded-2xl md:rounded-3xl max-w-md text-center w-full" data-id="element-220">
              <h3 className="text-2xl md:text-4xl font-light mb-3 md:mb-4" data-id="element-221">
                {rightLabel}
              </h3>
              <p className="text-gray-600 text-xs md:text-base leading-relaxed" data-id="element-222">
                {rightCopy}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="relative bg-gradient-to-b from-water-blue to-white py-12 md:py-20" data-id="element-223">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-water-accent/20 blur-2xl" data-id="element-224" />
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-225">
          <div className="relative" data-id="element-226">
            <div className="hidden md:block absolute -left-4 top-0 text-6xl text-water-accent/20 font-playfair" data-id="element-227">
              "
            </div>
            <p className="caption-text text-center text-base md:text-2xl text-gray-800 leading-relaxed px-4 md:px-8" data-id="element-228">
              {caption}
            </p>
            <div className="hidden md:block absolute -right-4 bottom-0 text-6xl text-water-accent/20 font-playfair" data-id="element-229">
              "
            </div>
          </div>
          <div className="flex justify-center mt-6 md:mt-8" data-id="element-230">
            <div className="w-16 md:w-24 h-px bg-gradient-to-r from-transparent via-water-accent to-transparent" data-id="element-231" />
          </div>
        </div>
      </div>
    </section>;
};